import React, { useEffect, useReducer } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { withHeaderMessages } from "../higherOrderComponents/WithHeaderMessages";
import { Currency } from "../lib/components/Currency";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from "../lib/components/LoadingSpinner";
import {
  FormattedDate,
  FormattedDateTime,
} from "../lib/components/FormattedDate";
import { Address } from "../lib/components/Address";

const ContractDetailsPrint = (props) => {
  const initialState = {
    isLoading: true,
    contract: {
      provider: {
        address: {},
      },
      purchaser: {
        address: {},
      },
      recipients: [],
    },
    payoff: {},
    disbursementPayouts: [],
    disbursementPayoutsLoading: true,
    payoffLoading: true,
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "contractDetails":
        return {
          ...state,
          contract: action.payload,
          isLoading: false,
        };
      case "payoff":
        return {
          ...state,
          payoff: action.payload,
          payoffLoading: false,
        };
      case "disbursementPayouts":
        return {
          ...state,
          disbursementPayouts: action.payload,
          disbursementPayoutsLoading: false,
        };
      case "payoffLoading":
        return {
          ...state,
          payoffLoading: action.paylod,
        };
      case "isLoading":
        return {
          ...state,
          isLoading: action.payload,
        };
      case "hideLoader":
        return {
          ...state,
          isLoading: false,
        };
      default:
        throw new Error();
    }
  };

  const [contractDetailsState, dispatch] = useReducer(reducer, initialState);
  const { number } = useParams();

  useEffect(() => {
    async function getContractDetails() {
      props.header.setHeader("contractDetailsPrint");
      await props.api
        .get(`/api/contract/${number}`)
        .then((response) => {
          if (response.status === 200) {
            return response.data;
          }
        })
        .then((data) => {
          dispatch({
            type: "contractDetails",
            payload: data,
          });
        })
        .catch(dispatch({ type: "hideLoader" }))
        .then(dispatch({ type: "hideLoader" }));
    }
    getContractDetails();
  }, []);

  useEffect(() => {
    async function getPayOffDetails() {
      await props.api
        .get(`/api/contract/${number}/payoff`)
        .then((response) => {
          if (response.status === 200) {
            return response.data;
          }
        })
        .then((data) => {
          dispatch({ type: "payoff", payload: data });
        })
        .catch(dispatch({ type: "hideLoader" }))
        .then(dispatch({ type: "hideLoader" }));
    }
    getPayOffDetails();
  }, []);

  useEffect(() => {
    async function getDisbursementPayoutDetails() {
      await props.api
        .get(`/api/contract/${number}/disbursement-payouts`)
        .then((response) => {
          if (response.status === 200) {
            return response.data;
          }
        })
        .then((data) => {
          dispatch({ type: "disbursementPayouts", paylod: data });
        })
        .catch(dispatch({ type: "hideLoader" }))
        .then(dispatch({ type: "hideLoader" }));
    }
    getDisbursementPayoutDetails();
  }, []);

  const hideLoader = () => {
    dispatch({ type: "isLoading", payload: false });
  };

  const chunkArray = (array, chunkSize) => {
    return Array(Math.ceil(array.length / chunkSize))
      .fill()
      .map((_, index) => index * chunkSize)
      .map((begin) => array.slice(begin, begin + chunkSize));
  };

  if (contractDetailsState.isLoading || contractDetailsState.payoffLoading) {
    //
    return <LoadingSpinner />;
  }

  const { contract, payoff } = contractDetailsState;
  const agents = [
    ...new Set(
      [contract.agent || {}]
        .concat(contract.purchaseAgents)
        .filter((a) => a.firstName || a.lastName)
        .map((a) => a.firstName + " " + a.lastName),
    ),
  ];
  const agentLabel =
    agents.length === 0 ? "" : agents.length === 1 ? "Agent:" : "Agents:";
  var customLogo = contract?.provider?.providerLogo;

  return (
    <>
      <Row>
        {customLogo ? (
          <Col xs={12} className="logo-container">
            <div className="receipt-header__inner justify-content-center">
              <div className="receipt-header__logo-wrap">
                <img
                  src={`data:${customLogo.contentType};base64,${customLogo.logoBase64}`}
                  alt="Customer logo"
                  className="receipt-header__logo__bigger"
                />
              </div>
            </div>
          </Col>
        ) : (
          <Col xs={12} style={{ textAlign: "center" }}>
            <img
              className="logo"
              src="/images/ClearPoint_Trust_Logo.jpg"
              alt="ClearPoint logo"
            />
          </Col>
        )}
      </Row>
      <Row>
        <Col sm={12}>
          <h4 className="mr-15 mt-2">Contract {contract.number} - Details</h4>
          <FormattedDateTime date={new Date()} />
        </Col>
      </Row>
      {contract.hasEarlyPayoffOption && !contract.earlyPayoffExpired && (
        <Row
          className="section mt-30 border-between"
          style={{ marginBottom: "30px" }}
        >
          <Col>
            <div class="alert alert-info" role="alert">
              <h4 class="alert-heading">Early Payoff</h4>
              <div>
                <p>
                  Contract has Early Payoff option and is within Grace Period
                  and can be paid off with{" "}
                  <Currency amount={contract.earlyPayoffAmount} />
                </p>
              </div>
              <div>
                <label>Grace Period ends:</label>{" "}
                <FormattedDate date={contract.earlyPayoffExpiresOn} />
              </div>
            </div>
          </Col>
        </Row>
      )}

      <Row
        className="section"
        style={{ marginBottom: "2px", marginTop: "20px" }}
      >
        <Col xs={6}>
          <div>
            <label>Provider Contract #</label> {contract.providerNumber}
          </div>
        </Col>
        <Col xs={6}>
          <div>
            <label>Status</label> {contract.status}
          </div>
        </Col>
      </Row>
      <Row className="section" style={{ marginBottom: "2px" }}>
        <Col xs={6}>
          <div>
            <label>Guaranteed?</label> {contract.guaranteed ? "Yes" : "No"}
          </div>
        </Col>
        <Col xs={6}>
          <div>
            <label>Irrevocable?</label> {contract.irrevocable ? "Yes" : "No"}
          </div>
        </Col>
      </Row>
      <Row className="section" style={{ marginBottom: "2px" }}>
        <Col xs={6}>
          <div>
            <label>Accepted Date</label>{" "}
            <FormattedDate date={contract.accepted} />
          </div>
        </Col>
        <Col xs={6}>
          <div>
            <label>Signed Date</label> <FormattedDate date={contract.signed} />
          </div>
        </Col>
      </Row>
      <Row className="section" style={{ marginBottom: "2px" }}>
        <Col xs={6}>
          <div>
            <label>At Need / Property Only?</label>{" "}
            {contract.atNeed ? "Yes" : "No"}
          </div>
        </Col>
        <Col xs={6}></Col>
      </Row>

      <Row
        className="section"
        style={{ marginTop: "20px", marginBottom: "2px" }}
      >
        <Col xs={6}>
          <div>
            <label>Plan Total:</label> <Currency amount={contract.netPrice} />
          </div>
        </Col>
        <Col xs={6}>
          <div>
            <label>Payoff Amount:</label>{" "}
            <Currency amount={payoff && payoff.payoffAmount} />
          </div>
        </Col>
      </Row>
      <Row className="section" style={{ marginBottom: "2px" }}>
        <Col xs={6}>
          <div>
            <label>Amount Paid:</label> <Currency amount={contract.paid} />
            {contract.nonWaivedNonKeptProviderFees &&
            contract.nonWaivedNonKeptProviderFees !== 0
              ? "**"
              : ""}
          </div>
        </Col>
        <Col xs={6}>
          <div>
            <label>Total Retained:</label>{" "}
            <Currency amount={contract.retained} />
          </div>
        </Col>
      </Row>
      <Row className="section" style={{ marginBottom: "2px" }}>
        <Col xs={6}>
          <div>
            <label>Plan Balance:</label> <Currency amount={contract.balance} />
          </div>
        </Col>
        <Col xs={6}>
          <div>
            <label>Total Income:</label> <Currency amount={contract.income} />
          </div>
        </Col>
      </Row>
      <Row className="section" style={{ marginBottom: "2px" }}>
        <Col xs={6}>
          <div>
            <label>Payoff Finance Amount:</label>{" "}
            <Currency amount={payoff && payoff.payoffFinanceChargeAmount} />
          </div>
        </Col>
        <Col xs={6}>
          <div>
            <label>Current Value:</label> <Currency amount={contract.value} />
          </div>
        </Col>
      </Row>
      {contract.nonWaivedNonKeptProviderFees &&
        contract.nonWaivedNonKeptProviderFees !== 0 && (
          <Row className="section" style={{ marginBottom: "2px" }}>
            <Col xs={12}>
              <div>
                ** Includes Finance Charges and/or other Provider Fees of{" "}
                <Currency amount={contract.nonWaivedNonKeptProviderFees} />
              </div>
            </Col>
          </Row>
        )}

      <Row className="" style={{ marginTop: "20px" }}>
        <Col xs={12} className="contract-details">
          <label>Provider:</label>
          <div>
            {contract.provider.name} ({contract.provider.code})<br />
            <Address address={contract.provider.address} />
          </div>
        </Col>
      </Row>
      {agents && agents.length > 0 && (
        <Row className="" style={{ marginTop: "20px" }}>
          <Col xs={12} className="contract-details">
            <label>{agentLabel}</label>
            <div>
              {agents.map((a, ai) => (
                <div key={ai}>{a}</div>
              ))}
            </div>
          </Col>
        </Row>
      )}
      <Row className="" style={{ marginTop: "20px" }}>
        <Col xs={12} className="contract-details">
          <label>Recipients:</label>
          <div>
            {contract.recipients.map((r, ri) => (
              <div key={ri}>
                {r.firstName} {r.lastName}
                <br />
                <Address address={r.address} />
                <br />
              </div>
            ))}
          </div>
        </Col>
      </Row>
      <Row className="" style={{ marginTop: "0px" }}>
        <Col xs={12} className="contract-details">
          <label>Purchaser:</label>
          <div>
            {contract.purchaser.firstName} {contract.purchaser.lastName}
            <br />
            <Address address={contract.purchaser.address} />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default withHeaderMessages(WithApiAccess(ContractDetailsPrint));
